import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=718cd7a7&"
var script = {}
import style0 from "../../../assets/styles/panels/_Accordion.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports